import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home'

import {store} from '@/store/store'

import Login from '@/components/login/Login'
import ResetearPassword from '@/components/login/ResetearPassword'
import ModificarPassword from '@/components/login/ModificarPassword'
import ExpiredPassword from '@/components/login/ExpiredPassword'

import ListadoIncidencias from '@/components/incidencias/lista'
import verIncidencia from '@/components/incidencias/verIncidencia'
import nuevaVisita from '@/components/incidencias/nuevaVisita'
import datosVisita from '@/components/incidencias/datosVisita'
import maestros from '@/components/incidencias/maestros'
import nuevoOficio from '@/components/incidencias/maestros/oficios'
import nuevoSuboficio from '@/components/incidencias/maestros/suboficios'

import Gestion from '@/components/gestion/gestion/'
import sociedades from '@/components/gestion/childs/sociedades'
import promociones from '@/components/gestion/childs/promociones'
import proveedores from '@/components/gestion/childs/proveedores'
import inmuebles from '@/components/gestion/childs/inmuebles'
import clientes from '@/components/gestion/childs/clientes'
import operaciones from '@/components/gestion/childs/operaciones'
import tiposInmueble from '@/components/gestion/childs/tiposInmueble'
/* import tiposVisita from '@/components/gestion/childs/tiposVisita'
import urgencias from '@/components/gestion/childs/urgencias'
import estadosIncidencias from '@/components/gestion/childs/estadosIncidencias' */


import provOficioPromo from '@/components/incidencias/maestros/provOficioPromo'
import inmueblesEspeciales from '@/components/incidencias/maestros/inmueblesEspeciales'
import inmueblesEspecialesPromo from '@/components/incidencias/maestros/inmueblesEspecialesPromo'
import clientesEspeciales from '@/components/incidencias/maestros/clientesEspeciales'
import clientesEspecialesPromo from '@/components/incidencias/maestros/clientesEspecialesPromo'
import tiposParte from '@/components/incidencias/maestros/tiposParte'
import tiposReclamacion from '@/components/incidencias/maestros/tiposReclamacion'
import incidenciasPredef from '@/components/incidencias/maestros/incidenciasPredef'
import estanciasTipoInmueble from '@/components/incidencias/maestros/estanciasTipoInmueble'
import mensajesTipoEstado from '@/components/incidencias/maestros/mensajesTipoEstado'

import DatosIncidencia from '@/components/incidencias/detalleIncidencia/datosIncidencia'
import DatosVisita from '@/components/incidencias/detalleIncidencia/datosVisita'
import Evolucion from '@/components/incidencias/detalleIncidencia/evolucion'
import Documentacion from '@/components/incidencias/detalleIncidencia/documentacion'

import chat from '@/components/chat/ChatContainer'
import SolicitudesRolCliente from '@/components/rolCliente/listaRolCliente'
import crearVisitasSolicitudes from '@/components/rolCliente/crearVisitasSolicitudes'

import configuracion from './configuracion'
import informes from './informes'
import perfil from './perfil'

Vue.use(Router)

let userRol = ''

const router = new Router({
  routes: [
    // Login
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/resetear_password',
      name: 'login.resetearPassword',
      component: ResetearPassword
    },
    {
      path: '/modificar_password',
      name: 'login.modificarPassword',
      component: ModificarPassword
    },
    {
      path: '/expired_password',
      name: 'login.expiredPassword',
      component: ExpiredPassword
    },
    {
      path: '/',
      name: 'root',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    // ROL CLIENTE
    {
      path: '/solicitudes-cliente',
      name: 'solicitudesRolCliente',
      component: SolicitudesRolCliente
    },
    {
      path: '/nueva-visita-solicitud',
      name: 'nuevaVisitaSolicitud',
      component: crearVisitasSolicitudes
    },
    // RUTAS ADMINISTRADOR
    {
      path: '/gestion',
      name: 'gestion',
      component: Gestion,
      children: [
        { path: 'sociedades', component: sociedades },
        { path: 'promociones', component: promociones },
        { path: 'proveedores', component: proveedores },
        { path: 'inmuebles', component: inmuebles },
        { path: 'clientes', component: clientes },
        { path: 'operaciones', component: operaciones },
        { path: 'tipos-de-inmueble', component: tiposInmueble },
        /* { path: 'tipos-de-visita', component: tiposVisita },
        { path: 'urgencias', component: urgencias },
        { path: 'estadosIncidencias', component: estadosIncidencias }, */
      ]
    },
    // RUTAS POSVENTA
    {
      path: '/solicitudes',
      name: 'incidencias',
      component: ListadoIncidencias,
      props: true
    },
    {
      path: '/solicitudes/:idIncidencia',
      name: 'detalleIncidencia',
      props: true,
      component: verIncidencia,
      children: [
        { path: 'datos-incidencia', component: DatosIncidencia },
        { path: 'datos-visita', component: DatosVisita },
        { path: 'evolucion', component: Evolucion },
        { path: 'documentacion', component: Documentacion }
      ]
    },
    {
      path: '/nueva-visita',
      name: 'nueva-visita',
      component: nuevaVisita,
      props: true
    },
    {
      path: '/nueva-visita/datos-visita-:actualVisitId',
      component: datosVisita,
      name: 'datosVisita',
      props: true
    },
    {
      path: '/maestros',
      name: 'maestros',
      component: maestros,
      children: [
        { path: 'nuevo-oficio', component: nuevoOficio, name: 'nuevoOficio' },
        { path: 'nuevo-suboficio', component: nuevoSuboficio },
        { path: 'prov-oficio-promo', component: provOficioPromo },
        { path: 'inmuebles-especiales', component: inmueblesEspeciales },
        { path: 'inmuebles-especiales-promo', component: inmueblesEspecialesPromo },
        { path: 'clientes-especiales', component: clientesEspeciales },
        { path: 'clientes-especiales-promo', component: clientesEspecialesPromo },
        { path: 'tipos-parte', component: tiposParte },
        { path: 'tipos-inmueble', component: tiposInmueble },
        { path: 'tipos-reclamacion', component: tiposReclamacion },
        { path: 'incidencias-predefinidas', component: incidenciasPredef },
        { path: 'estancias-tipo-inmueble', component: estanciasTipoInmueble },
        { path: 'mensajes-tipo-estado', component: mensajesTipoEstado }
      ]
    },
    {
      path: '/chat',
      name: 'chat',
      component: chat
    },
    ...configuracion,
    ...informes,
    ...perfil
  ],
  mode: 'history',
  // base: '/htdocs2/desarrollo/mcastro/posventa-rol-cliente/'
  base: process.env.VUE_APP_routerBase
  // base: '/posventa_2.0'
  // base: '/htdocs2/desarrollo/mcastro/posventa'
})

export const necesitaAuth = function (routeName) {
  console.log('necesitaAuth esta página?: ', routeName === null || !routeName.startsWith('login') || routeName === 'login.modificarPassword')
  return routeName === null || !routeName.startsWith('login') || routeName === 'login.modificarPassword'
}

router.beforeEach(async (to, from, next) => {
  const usuarioJson = JSON.parse(localStorage.getItem('usuario')) || false
  console.log('usuariojson', usuarioJson)
  if (usuarioJson !== false) {
    await store.dispatch('login/comprobarSesion', usuarioJson)
  }
  const usuarioStore = store.getters['login/usuario'];
  if (usuarioStore.token != null && usuarioStore.id != null && usuarioJson.token != usuarioStore.token) {
    await store.dispatch('login/comprobarSesion', usuarioStore)
  }

  if (to.name === 'detalleIncidencia') {
    console.log('voy a detalleIncidencia id: ', typeof(to.params.idIncidencia))
    await store.dispatch('incidencias/checkAccesoUsuario', {
      idIncidencia: to.params.idIncidencia
    })
    if (store.state.incidencias.tieneAcceso === true) {
      console.log('TENGO ACCESO: ', store.state.incidencias.tieneAcceso)
      next()
    } else {
      console.log('NO TENGO ACCESO: ', store.state.incidencias.tieneAcceso)
      next({ name: 'solicitudesRolCliente' })
    }
  }
  if (localStorage.usuario) {
    let roles = JSON.parse(localStorage.usuario).roles
    if(roles.includes('PV_SUPERVISOR'))
      userRol = 'PV_SUPERVISOR'
    else if(roles.includes('PV_CLIENTE'))
      userRol = 'PV_CLIENTE'
    else if(roles.includes('PV_ADMINISTRADOR'))
      userRol = 'PV_ADMINISTRADOR'
    else if(roles.includes('PV_PROVEEDOR'))
      userRol = 'PV_PROVEEDOR'

    store.commit('login/setRolAdmin', userRol === 'PV_ADMINISTRADOR' ? true : false)
    store.commit('login/setRolCliente', userRol === 'PV_CLIENTE' ? true : false)
    store.commit('login/setRolProveedor', userRol === 'PV_PROVEEDOR' ? true : false)

  }
  // console.log('AQUI YA TENGO USER ROL: ', userRol)
  if (store.getters['login/loaded']) {
    if (!necesitaAuth(to.name)) {
      // console.log('me voy por aqui, si no estoy auth')
      next()
    } else if (store.getters['login/loggedIn']) {
      if (store.getters['login/passwordUsoUnico'] && to.name !== 'login.modificarPassword') {
        // console.log('SI ESTOY LOGGED Y TENGO PASSWORD UNICO - FUERZA RESET PASS')
        next({ name: 'login.modificarPassword' })
      } else {
        // console.log('SI ESTOY LOGGED Y NO TENGO PASSWORD UNICO - ME EJECUTO SIEMPRE SI ESTAS LOGGED')
        // console.log('userROL: ', userRol)
        // cargo incidencias si soy PV_CLIENTE y quiero ir a 'home'
        if (userRol === 'PV_CLIENTE' && to.name === 'home' || userRol === 'PV_CLIENTE' && to.name === 'root') {
          next({ name: 'solicitudesRolCliente' })
        }
        else if(userRol === 'PV_ADMINISTRADOR' && to.name === 'home' || userRol === 'PV_ADMINISTRADOR' && to.name === 'root'){
          next({ name: 'gestion'})
        } else if (userRol === 'PV_PROVEEDOR' && to.name === 'home' || userRol === 'PV_PROVEEDOR' && to.name === 'root') {
          next({ name: 'incidencias' })
        } else {
          next()
        }
        if (to.name === 'detalleIncidencia') {
          console.log('voy a detalleIncidencia id: ', to)
          store.dispatch('incidencias/checkAccesoUsuario', {
            idIncidencia: to.params.idIncidencia
          })
          if (store.state.incidencias.tieneAcceso === true) {
            console.log('TENGO ACCESO: ', store.state.incidencias.tieneAcceso)
            next()
          } else {
            console.log('NO TENGO ACCESO: ', store.state.incidencias.tieneAcceso)
            next(false)
          }
          //comprobar si tiene acceso por medio del endpoint del WS
        }
      }
    } else {
      next({ name: 'login' })
    }
  } else {
    // Si acabo de entrar se encarga la App de comprobar si estoy logueado
    // console.log('SOLO PRIMERA CARGA')
    if (userRol === 'PV_CLIENTE' && to.name === 'home') {
      next({ name: 'solicitudesRolCliente' })
    } else if (userRol === 'PV_ADMINISTRADOR' && to.name === 'home') {
      next({ name: 'gestion' })
    } else {
      next()
    }
  }
})

router.beforeEach(async (to, from, next) => {
  if(from.name === 'datosVisita') {
    // queremos salir de datos visita, revisamos que tenga que preguntar para enviar mail
    const visitaModificada = store.getters['incidencias/getVisitaModificada'];

    if(visitaModificada) {
      store.dispatch('incidencias/mostrarPopupConfirmar')
      store.dispatch('guardarRutaAnulada', to.path)
      return;
    }
  }
  next();
});

export default router
